import { assign } from 'xstate';
import type { InterpreterOptions, MachineOptions } from 'xstate';
import type { UiEvent } from './events';
import type { UiContext } from './context';
import { IS_DEBUG } from '../utils/debug';

export const machineOptions: MachineOptions<UiContext, UiEvent> = {
	guards: {},
	actions: {
		/* Blur */
		blurBackground: assign<UiContext, UiEvent>({
			backgroundBlurred: true
		}),
		clearBackground: assign<UiContext, UiEvent>({
			backgroundBlurred: false
		}),
		/* Fog */
		mapFog: assign<UiContext, UiEvent>({
			fogLevel: 'map'
		}),
		personasFog: assign<UiContext, UiEvent>({
			fogLevel: 'personas'
		}),
		clearFog: assign<UiContext, UiEvent>({
			fogLevel: null
		}),
		/* Personas */
		hiddenPersonas: assign<UiContext, UiEvent>({
			personasVisible: false,
			personasEnabled: false,
			personasEnabledIndex: null
		}),
		disabledPersonas: assign<UiContext, UiEvent>({
			personasVisible: true,
			personasEnabled: false,
			personasEnabledIndex: null
		}),
		enabledPersonas: assign<UiContext, UiEvent>({
			personasVisible: true,
			personasEnabled: true,
			personasEnabledIndex: null
		}),
		/* Toolbars */
		hiddenToolbars: assign<UiContext, UiEvent>({
			toolbarScoreVisible: false,
			toolbarConceptsVisible: false,
			toolbarConceptsEnabled: false
		}),
		enabledToolbars: assign<UiContext, UiEvent>({
			toolbarScoreVisible: true,
			toolbarConceptsVisible: true,
			toolbarConceptsEnabled: true
		}),
		/* Reactions (Feedback + Score) */
		hiddenReactions: assign<UiContext, UiEvent>({
			feedbackVisible: false,
			scoreVisible: false
		}),
		visibleReactions: assign<UiContext, UiEvent>({
			feedbackVisible: true,
			scoreVisible: true
		}),
		/* Tutorial */
		hiddenTutorial: assign<UiContext, UiEvent>({
			toolbarTutorialVisible: false
		}),
		visibleTutorial: assign<UiContext, UiEvent>({
			toolbarTutorialVisible: true
		}),
		/* Misc */
		hideEverything: assign<UiContext, UiEvent>({
			personasVisible: false,
			personasEnabled: false,
			personasEnabledIndex: null,
			feedbackVisible: false,
			toolbarScoreVisible: false,
			toolbarConceptsVisible: false,
			toolbarConceptsEnabled: false,
			scoreVisible: false,
			toolbarTutorialVisible: false
		})
	},
	activities: {},
	delays: {},
	services: {}
};

export const interpreterOptions: Partial<InterpreterOptions> = {
	id: 'MiniLautern XState',
	devTools: IS_DEBUG
};
